import React from "react";
import "./ExitButton.scss";

const ExitButton = ({ onClick, ...props }) => {
  return <button className="ExitButton" onClick={onClick} {...props} />;
};

export default ExitButton;
